// This file exports the privacy policy markdown content
// It's a workaround for Create React App which doesn't support direct .md imports

export const privacyPolicyMarkdown = `# Privacy Policy

Last updated: January 2025

## Introduction

At Pale, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services.

## Information We Collect

We may collect information about you in a variety of ways. The information we may collect includes:

- Personal information you provide when signing up for our waitlist or contacting us
- Usage data and analytics information about how you interact with our website
- Technical information such as IP address, browser type, and device information

## How We Use Your Information

We use the information we collect to:

- Provide, operate, and maintain our services
- Improve and personalize your experience
- Communicate with you about our services and updates
- Analyze usage patterns and trends
- Detect and prevent fraud or abuse

## Data Sharing and Disclosure

We do not sell your personal information. We may share your information only in the following circumstances:

- With service providers who assist us in operating our website and services
- When required by law or to protect our rights
- In connection with a business transfer or merger

## Data Security

We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure.

## Your Rights

Depending on your location, you may have certain rights regarding your personal information, including:

- The right to access your personal information
- The right to correct inaccurate information
- The right to delete your information
- The right to object to processing of your information
- The right to data portability

## Cookies and Tracking Technologies

We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.

## Third-Party Services

Our website may contain links to third-party websites or services. We are not responsible for the privacy practices of these third parties. We encourage you to read their privacy policies.

## Children's Privacy

Our services are not intended for children under the age of 13. We do not knowingly collect personal information from children under 13.

## Changes to This Privacy Policy

We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.

## Contact Us

If you have any questions about this Privacy Policy, please contact us through our website or the contact information provided in our services.
`;
